

import React from 'react';



































export const defaults = {
  actions: {
    getAddonsCost: void 0,
    getAddonsCostByType: void 0,
    getCostForAddon: void 0,
    getAddonValue: void 0,
    getAddonLabel: void 0,
    getFormattedAddon: void 0,
    getCaptions: void 0,
    getCurrencyIcon: void 0,
    mergeAddon: void 0,
    getCurrencySymbol: void 0,
    getSupersizeMyEdits: void 0,
    getAdditionalOutputs: void 0,
    getBillingEntityCode: void 0,
    formatAddons: void 0
  },
  constants: {
    ADDITIONAL_OUTPUT: void 0,
    ASPECT_RATIOS: void 0,
    DURATIONS: void 0,
    RUSH_EDIT: void 0,
    CAPTIONS: void 0,
    CAPTION_SAMPLES: void 0,
    CHROMA_KEY: void 0,
    SUPERSIZE_MY_EDIT: void 0
  }
};

const addonsContext = React.createContext(defaults);


export default addonsContext;
export const AddonsContextConsumer = addonsContext.Consumer;